import { createAction } from '@reduxjs/toolkit';
import { IAlertState } from '@store/alerts/types';

export class DeleteAlertFailure {
  static get action() {
    return createAction('notifications/DELETE_ALERT_FAILURE');
  }

  static get reducer() {
    return (draft: IAlertState) => {
      draft.requests.deleteNotificationsPending = false;
      return draft;
    };
  }
}
